import * as constants from '../constants'

export const accountUpdateSubmit = payload => ({ payload, type: constants.ACCOUNT_UPDATE_SUBMIT })
export const accountUpdateFailure = payload => ({ payload, type: constants.ACCOUNT_UPDATE_FAILURE })
